import React, { useState } from "react";
import { connect } from "react-redux";
import { useMountEffect, useUpdateEffect } from "../../../hooks/LifeCycle";
import IngresoActions from "../../../stores/ingreso/Actions";
import useEmpresa from "../../../hooks/useEmpresa";
import Text from "../../../components/Common/Text";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import Tooltip from "../../../components/Common/Tooltip";
import CustomInput from "../../../components/CustomForm/CustomInput";
import CustomIconInput from "../../../components/CustomForm/CustomIconInput";
import { FileAddOutlined } from "@ant-design/icons";
import CustomTable from "../../../components/CustomTable/CustomTable";
import {
  obtenerFrecuenciaValida,
  camposRequeridosCompletos,
} from "../utils/IngresoUtils";
import { cleanNumber } from "../../../utils/NumberUtil";
import { ALERTAS_GENERICAS } from "../../../utils/AlertasGenericas";
import { isEmptyValue } from "../../../utils/StringUtil";
import Spinner from "../../../components/Common/Spinner";
import CheckRender from "../../../components/Common/CheckRender";
import { cleanCurrency } from "../../../utils/CurrencyUtil";

const ProcedimientosPermitidosTabla = (props) => {
  const {
    formCierreCuentasData,
    getProcedimientosPermitidosCierreCuentasLoading,
    validarProcedimientoCierreCuentasLoading,
    authUserData
  } = props;
  const itemsPerPage = 10;
  const [query, setQuery] = useState("");
  const [procedimientosPermitidos, setProcedimientosPermitidos] = useState([]);
  const empresa = useEmpresa();
  const { prestador } = authUserData;

  useMountEffect(() => {
    props.getProcedimientosPermitidosCierreCuentas({
      formCierreCuentasData,
      compania: empresa?.CODIGO,
      formHandler: props.formCierreCuentas,
    });
  });

  useUpdateEffect(() => {
    setProcedimientosPermitidos(
      formCierreCuentasData?.procedimientosPermitidos
    );
  }, [formCierreCuentasData?.procedimientosPermitidos]);

  const filtrarBusqueda = (query) => {
    if (isEmptyValue(query)) {
      setProcedimientosPermitidos(
        formCierreCuentasData?.procedimientosPermitidos
      );
      return;
    }
    const procedimientosFiltrados =
      formCierreCuentasData?.procedimientosPermitidos?.filter(
        (procedimiento) => {
          const codigoProcedimientoMatch = String(procedimiento.cobertura)
            ?.toLowerCase()
            ?.includes(query.toLowerCase());

          const nombreProcedimientoMatch = procedimiento.nombreCobertura
            ?.toLowerCase()
            ?.includes(query.toLowerCase());

          return codigoProcedimientoMatch || nombreProcedimientoMatch;
        }
      );

    setProcedimientosPermitidos(procedimientosFiltrados);
  };

  const onQueryChange = () => (value) => {
    setQuery(value);
    filtrarBusqueda(value);
  };

  const onChangeFrecuencia = (value, record) => {
    const frecuencia = cleanNumber(value);

    const updatedList = procedimientosPermitidos.map((item) => {
      if (String(item.cobertura) === String(record?.cobertura)) {
        return {
          ...item,
          frecuencia,
        };
      }

      return item;
    });

    setProcedimientosPermitidos(updatedList);
  };

  const onChangeMontoReclamado = (value, record) => {
    const montoReclamado = cleanCurrency(value);

    const updatedList = procedimientosPermitidos.map((item) => {
      if (String(item.cobertura) === String(record?.cobertura)) {
        return {
          ...item,
          montoReclamado,
        };
      }

      return item;
    });

    setProcedimientosPermitidos(updatedList);
  };

  const agregarProcedimiento = (procedimiento) => {
    const {
      fechaServicio,
      fechaSalida,
      tipoPss,
      codigoPss,
    } = formCierreCuentasData;
    if (!camposRequeridosCompletos(formCierreCuentasData)) {
      props.formCierreCuentas({
        ...formCierreCuentasData,
        alertConfig: {
          type: "info",
          title: "¡Hola!",
          message: ALERTAS_GENERICAS.CAMPOS_REQUERIDOS,
          onConfirm: () => {
            props.formCierreCuentas({
              ...formCierreCuentasData,
              showAlert: false,
              showRequired: true,
            });
          },
        },
        showAlert: true,
        showRequired: true,
      });
      return;
    }

    if (
      isEmptyValue(tipoPss) ||
      isEmptyValue(codigoPss) ||
      Number(codigoPss) === 0
    ) {
      props.validarProcedimientoCierreCuentas({
        formCierreCuentasData: {
          ...formCierreCuentasData,
          tipoPss: prestador?.tipoPss,
          codigoPss: prestador?.codigo,
          montoReclamado: procedimiento?.montoReclamado
        },
        formHandler: props.formCierreCuentas,
        codigoProcedimiento: procedimiento?.cobertura,
        frecuencia: obtenerFrecuenciaValida(
          procedimiento?.frecuencia,
          procedimiento?.cobertura,
          fechaServicio,
          fechaSalida
        ),
      });
      return;
    }

    props.validarProcedimientoCierreCuentas({
      formCierreCuentasData: {
        ...formCierreCuentasData,
        montoReclamado: procedimiento?.montoReclamado
      },
      formHandler: props.formCierreCuentas,
      codigoProcedimiento: procedimiento?.cobertura,
      frecuencia: obtenerFrecuenciaValida(
        procedimiento?.frecuencia,
        procedimiento?.cobertura,
        fechaServicio,
        fechaSalida
      ),
    });
  };

  const columnasProcedimientosPermitidos = [
    {
      key: "cobertura",
      title: "Código",
      dataIndex: "cobertura",
    },
    {
      key: "nombreCobertura",
      title: "Descripción",
      dataIndex: "nombreCobertura",
    },
    {
      key: "montoReclamado",
      title: "Monto Reclamado",
      dataIndex: "montoReclamado",
      render: (text, record) => {
        return (
          <CustomIconInput
            type={"text"}
            value={record?.montoReclamado}
            onChange={(value) => onChangeMontoReclamado(value, record)}
            width={"80px"}
          />
        );
      },
    },
    {
      key: "frecuencia",
      title: "Frecuencia",
      dataIndex: "frecuencia",
      render: (text, record) => {
        return (
          <CustomIconInput
            type={"text"}
            value={record?.frecuencia}
            onChange={(value) => onChangeFrecuencia(value, record)}
            width={"50px"}
          />
        );
      },
    },
    {
      key: "action",
      title: "Acción",
      render: (text, record) => (
        <Tooltip text="Agregar">
          <CheckRender allowed={!validarProcedimientoCierreCuentasLoading}>
            <FileAddOutlined
              style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 25 }}
              onClick={() => {
                agregarProcedimiento(record);
              }}
            />
          </CheckRender>
        </Tooltip>
      ),
    },
  ];

  return (
    <div>
      <Text size="24px" isTittle={true} weight={"bold"}>
        {"Agregar Procedimiento"}
      </Text>

      <CustomInput
        type={"text"}
        placeholder={"Buscar"}
        value={query}
        onChange={onQueryChange()}
      />

      <CustomSeparator height={"10px"} />

      <CheckRender allowed={getProcedimientosPermitidosCierreCuentasLoading}>
        <Spinner size={20} colorBorderTop={empresa?.COLOR_PRINCIPAL} />
      </CheckRender>

      <CustomTable
        columns={columnasProcedimientosPermitidos}
        dataSource={procedimientosPermitidos || []}
        showPagination={true}
        pageSize={itemsPerPage}
      />

      <CustomSeparator height={"20px"} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  formCierreCuentasData: state.ingreso.formCierreCuentasData,
  formCierreCuentasLoading: state.ingreso.formCierreCuentasLoading,

  validarProcedimientoCierreCuentasLoading:
    state.ingreso.validarProcedimientoCierreCuentasLoading,
  getProcedimientosPermitidosCierreCuentasLoading:
    state.ingreso.getProcedimientosPermitidosCierreCuentasLoading,
});

const mapDispatchToProps = {
  formCierreCuentas: IngresoActions.formCierreCuentas,
  validarProcedimientoCierreCuentas:
    IngresoActions.validarProcedimientoCierreCuentas,
  getProcedimientosPermitidosCierreCuentas:
    IngresoActions.getProcedimientosPermitidosCierreCuentas,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(ProcedimientosPermitidosTabla);
